var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Mall.RechargeConfig",
    "options": {
        "objc_class_prefix": "MallRechargeConfig",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "channel",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "rewardType",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "rewardConfigId",
                    "id": 4
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "repeated",
                    "type": "RechargeConfig",
                    "name": "rechargeConfigs",
                    "id": 1
                },
                {
                    "rule": "repeated",
                    "type": "string",
                    "name": "channels",
                    "id": 2
                },
                {
                    "rule": "repeated",
                    "type": "RechargeConfig",
                    "name": "wxpay",
                    "id": 3
                },
                {
                    "rule": "repeated",
                    "type": "RechargeConfig",
                    "name": "alipay",
                    "id": 4
                },
                {
                    "rule": "repeated",
                    "type": "RechargeConfig",
                    "name": "IAP",
                    "id": 5
                },
                {
                    "rule": "repeated",
                    "type": "RechargeConfig",
                    "name": "IAB",
                    "id": 6
                },
                {
                    "rule": "repeated",
                    "type": "RechargeConfig",
                    "name": "others",
                    "id": 7
                },
                {
                    "rule": "repeated",
                    "type": "ChannelGroup",
                    "name": "groups",
                    "id": 8
                }
            ]
        },
        {
            "name": "RechargeConfig",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "configId",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "description",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "amount",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "icon",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "money",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "currency",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "currencySymbol",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "residue",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "rewardConfigId",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "rewardDesc",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "proportion",
                    "id": 12
                }
            ]
        },
        {
            "name": "RechargeConfigList",
            "fields": [
                {
                    "rule": "repeated",
                    "type": "RechargeConfig",
                    "name": "rechargeConfigList",
                    "id": 1
                }
            ]
        },
        {
            "name": "ChannelGroup",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "groupCode",
                    "id": 1
                },
                {
                    "rule": "repeated",
                    "type": "string",
                    "name": "channels",
                    "id": 2
                },
                {
                    "rule": "map",
                    "type": "RechargeConfigList",
                    "keytype": "string",
                    "name": "channelRechargeConfigMap",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "groupName",
                    "id": 4
                },
                {
                    "rule": "map",
                    "type": "string",
                    "keytype": "string",
                    "name": "channelNameMap",
                    "id": 5
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/orderview/optionlistpb.js